import "./index-Bh5idiRE.mjs";
import i18n from "i18next";
function getCurrentYear() {
  const locale = i18n.language;
  const currentDate = /* @__PURE__ */ new Date();
  const currentYear = new Intl.DateTimeFormat(locale, { year: "numeric" }).format(currentDate);
  return currentYear;
}
function getCurrentMonth() {
  const locale = i18n.language;
  const currentDate = /* @__PURE__ */ new Date();
  const currentMonth = new Intl.DateTimeFormat(locale, { month: "long" }).format(currentDate);
  return currentMonth;
}
function formatDate({ value, locale = i18n.language, options }) {
  const date = typeof value === "string" || typeof value === "number" ? new Date(value) : value;
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date provided");
  }
  const formatter = new Intl.DateTimeFormat(locale, options);
  return formatter.format(date);
}
const DEFAULT_PRECISION = 2;
function round(number, precision) {
  const numberString = String(number);
  const precisionString = String(precision);
  return Number(String(Math.round(Number(numberString + "e" + precisionString))) + "e-" + precisionString);
}
function toFixedTwo(number) {
  return round(number, DEFAULT_PRECISION);
}
function formatNumber(number, options) {
  const locale = (options == null ? void 0 : options.locale) ?? i18n.language;
  const precision = (options == null ? void 0 : options.precision) ?? DEFAULT_PRECISION;
  let postfix = "";
  const formatOptions = {
    maximumFractionDigits: precision
  };
  if (options == null ? void 0 : options.hasTrailingZeros) {
    formatOptions.minimumFractionDigits = precision;
  }
  if (options == null ? void 0 : options.percent) {
    if (options.percent === "real") {
      formatOptions.style = "percent";
    }
    if (options.percent === "sign-only") {
      postfix = "%";
    }
  }
  if (options == null ? void 0 : options.currency) {
    formatOptions.style = "currency";
    formatOptions.currency = options.currency;
  }
  if (options == null ? void 0 : options.hasSign) {
    formatOptions.signDisplay = "always";
  }
  const formatter = new Intl.NumberFormat(locale, formatOptions);
  return `${formatter.format(round(number, precision))}${postfix}`;
}
function parseNumber(value) {
  const parsedNumber = parseFloat(value);
  if (isNaN(parsedNumber)) {
    return null;
  }
  return parsedNumber;
}
const protocolRegex = /^https?:\/\//;
function getDomain(url) {
  return url.replace(protocolRegex, "");
}
export {
  getCurrentMonth as a,
  formatNumber as b,
  getDomain as c,
  formatDate as f,
  getCurrentYear as g,
  parseNumber as p,
  round as r,
  toFixedTwo as t
};
